import { useRef, useState } from "react"
import { useSelector } from "react-redux";
import { anyLongDisablingProcess } from "../../../../reducers/disablingProcesses";
import { getSavedAlbumsLayout, getSavedAlbumsOrder } from "../../../../reducers/albumListState";
import { Button, Typography } from "@mui/material";
import { GridView, List } from "@mui/icons-material";
import { ALBUM_LAYOUTS } from "../../../../utils/constants/enumConstants";
import AlbumLayoutOrderMenu from "./AlbumLayoutOrderMenu";

const AlbumLayoutOrderSelector = () => {
    const [windowOpen, setWindowOpen] = useState(false);
    const disabled = useSelector(anyLongDisablingProcess);
    const layout = useSelector(getSavedAlbumsLayout);
    const order = useSelector(getSavedAlbumsOrder);

    const onClick = () => setWindowOpen(!windowOpen);
    const closeWindow = () => setWindowOpen(false);

    const buttonRef = useRef();

    return (
        <>
            <Button 
                ref={buttonRef}
                disabled={disabled} 
                color="primary" 
                onClick={onClick} 
                sx={{ textTransform: 'none' }}
                endIcon={layout === ALBUM_LAYOUTS.grid ? <GridView /> : <List />}
            >
                <Typography noWrap>{order}</Typography>
            </Button>
            <AlbumLayoutOrderMenu
                open={windowOpen}
                anchor={buttonRef && buttonRef.current}
                closeHandler={closeWindow} />
        </>        
    )
}

export default AlbumLayoutOrderSelector;